import * as React from 'react';

const useOnExpand = (props)=>{
    const { initialIsExpanded , onExpandCallback  } = props;
    const [isExpanded, setIsExpanded] = React.useState(initialIsExpanded);
    const onExpand = (doExpand)=>{
        setIsExpanded((current)=>typeof doExpand === 'boolean' ? doExpand : !current
        );
        onExpandCallback === null || onExpandCallback === void 0 ? void 0 : onExpandCallback();
    };
    React.useEffect(()=>setIsExpanded(initialIsExpanded)
    , [
        initialIsExpanded
    ]);
    return {
        isExpanded,
        onExpand
    };
};

export { useOnExpand };
//# sourceMappingURL=use-on-expand.js.map
